// extracted by mini-css-extract-plugin
var _1 = "iiRY3dv5Oi0ryk0efbKA";
var _2 = "WQVAIElXPtUOEa_x0vB6";
export { _1 as "hasNoMobileUrl", _2 as "link" }
